<template>
    <header
        class="header"
        :class="[
            {
                transparent: isInvisible,
                index: $route.meta.headerPositionContent,
                isTelegram: getIsTelegram && getIsFullScreenOpen,
            },
        ]"
    >
        <div class="header__container">
            <div class="header__wrapper">
                <div class="header__left">
                    <div
                        class="header__left_burger"
                        @click="changeBurger(false)"
                    >
                        <div class="header__left_burger_line"></div>
                        <div class="header__left_burger_line"></div>
                        <div class="header__left_burger_line"></div>
                    </div>
                    <router-link to="/" custom v-slot="{ navigate, href }">
                        <a
                            :href="href"
                            aria-label="Logo"
                            class="header__left_logo"
                            @click="clickedLink($event, navigate)"
                        >
                            <div class="header__left_logo_img">
                                <Logo />
                            </div>
                        </a>
                    </router-link>
                </div>
                <nav class="header__center">
                    <ul class="header__list">
                        <li
                            class="header__list_item"
                            v-for="(item, index) in routes.mainNav"
                            :key="item.name"
                        >
                            <router-link
                                class="header__list_link"
                                :to="getLink(item)"
                            >
                                {{ $t(`message.${item.name}`) }}</router-link
                            >
                        </li>
                        <li class="header__list_item" v-if="isLoggedIn">
                            <router-link
                                class="header__list_link"
                                :class="{
                                    'router-link-exact-active':
                                        $route.href === '/my/history' ||
                                        $route.href === '/my/viewing' ||
                                        $route.href === '/my/history',
                                }"
                                to="/my/favourites"
                            >
                                {{ $t("message.myMovies") }}
                            </router-link>
                        </li>
                        <li class="header__list_item">
                            <router-link
                                class="header__list_link"
                                to="/cabinet"
                            >
                                {{ $t("message.tariffs") }}
                            </router-link>
                        </li>
                    </ul>
                </nav>
                <ul class="header__right">
                    <li class="header__right__icon header__right__icon--promo">
                        <ElButton
                            size="small"
                            type="default"
                            @click="payPerAction"
                            :attrs="{
                                'aria-label': $t('message.promobtn'),
                                class: 'big',
                            }"
                            v-if="isLoggedIn ? getAlreadyActivateOneSum : false"
                        >
                            <template #icon-left>
                                <Promo />
                            </template>
                            {{ $t("message.promobtn") }}
                        </ElButton>
                        <ElButton
                            size="small"
                            type="default"
                            square
                            v-if="isLoggedIn ? getAlreadyActivateOneSum : false"
                            @click="payPerAction"
                            :attrs="{
                                'aria-label': $t('message.promobtn'),
                                class: 'mini',
                            }"
                        >
                            <template #icon-left>
                                <Promo />
                            </template>
                        </ElButton>
                    </li>
                    <li class="header__right__icon header__right__icon--search">
                        <button
                            class="header__right__icon_btn"
                            :aria-label="$t('message.searchPlaceholder')"
                            @click="SearchCheck()"
                        >
                            <Search />
                        </button>
                    </li>
                    <li
                        class="header__right__icon header__right__icon--notification"
                    >
                        <router-link
                            class="header__right__icon_btn"
                            :class="{
                                'header__right__icon_btn--active':
                                    notificationCounter,
                            }"
                            :aria-label="$t('message.notifications')"
                            :data-counter="notificationCounter"
                            to="/notifications"
                        >
                            <Notification />
                        </router-link>
                    </li>
                    <li class="header__right__icon header__right__icon--lang">
                        <button
                            id="modalId"
                            aria-label="Язык"
                            class="wrapperLang"
                            :class="{ 'wrapperLang-open': isLangModalOpen }"
                            @click="toggleLang()"
                        >
                            <div class="wrapperLang__current">
                                {{ $i18n.locale === "uz" ? "uz" : "ru" }}
                            </div>
                            <div class="langModal">
                                <button
                                    @click.stop="langTo('ru')"
                                    class="firstLangItem"
                                    aria-label="ru"
                                    :tabindex="isLangModalOpen ? 0 : -1"
                                    :class="{
                                        langItem: true,
                                        activeLang: $i18n.locale === 'ru',
                                    }"
                                >
                                    Русский
                                </button>
                                <button
                                    @click.stop="langTo('uz')"
                                    aria-label="uz"
                                    :tabindex="isLangModalOpen ? 0 : -1"
                                    :class="{
                                        langItem: true,
                                        activeLang: $i18n.locale === 'uz',
                                    }"
                                >
                                    O'zbekcha
                                </button>
                            </div>
                        </button>
                    </li>
                    <template v-if="!isLoggedIn">
                        <li
                            class="header__right__icon header__right__icon--enter"
                        >
                            <!-- <router-link
                            class="header__right__icon_btn"
                            :aria-label="$t('message.login')"
                            to="/login"
                        >
                            <Enter />
                        </router-link> -->
                            <ElButton
                                size="small"
                                type="default"
                                :attrs="{
                                    'aria-label': $t('message.login-btn'),
                                }"
                                @click="$router.push('/login')"
                            >
                                {{ $t("message.login-btn") }}
                            </ElButton>
                        </li>
                        <li
                            class="header__right__icon header__right__icon--enter-mobile"
                        >
                            <button
                                class="header__right__icon_btn"
                                :aria-label="$t('message.searchPlaceholder')"
                                @click="$router.push('/login')"
                            >
                                <Enter />
                            </button>
                        </li>
                    </template>
                    <li
                        class="header__right__icon header__right__icon--accaunt"
                        v-else
                    >
                        <router-link
                            class="header__right__icon_btn"
                            aria-label="личный кабинет"
                            to="/cabinet"
                        >
                            <Account />
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
        <BurgerMenu
            :changeBurger="changeBurger"
            :isCloseBurger="isCloseBurger"
            v-if="windowWidth < 1200"
        />
    </header>
    <PaymentModal
        :type="getModalTypes[getIsPaymentModalActiveType]"
        v-if="isLoggedIn"
        @paymnetSuccess="paymnetSuccess"
    />
</template>
<script>
import { defineAsyncComponent } from "vue";
import { getCurrentInstance } from "vue";
import { routes } from "../router/routes";
import { useEventListener } from "../useEventListener";
import { mapGetters, mapActions } from "vuex";
const Logo = defineAsyncComponent(() => import("./HeaderIcon/Logo.vue"));
const Search = defineAsyncComponent(() => import("./HeaderIcon/Search.vue"));
const Notification = defineAsyncComponent(() =>
    import("./HeaderIcon/Notification.vue")
);
const Enter = defineAsyncComponent(() => import("./HeaderIcon/Enter.vue"));
const Account = defineAsyncComponent(() => import("./HeaderIcon/Account.vue"));
const Promo = defineAsyncComponent(() => import("./HeaderIcon/Promo.vue"));
const ElButton = defineAsyncComponent(() => import("./ElButton/index.vue"));
const ElLink = defineAsyncComponent(() => import("./ElLink/index.vue"));
const PaymentModal = defineAsyncComponent(() =>
    import("./paymentModal/index.vue")
);
const BurgerMenu = defineAsyncComponent(() => import("./BurgerMenu.vue"));
import {
    GetAllTarrifs,
    fetchCustomerTariffList,
    subscriptionList,
} from "../Api";
export default {
    components: {
        Logo,
        BurgerMenu,
        ElButton,
        Search,
        Notification,
        Enter,
        Promo,
        ElLink,
        PaymentModal,
        Account,
    },
    data() {
        return {
            routes,
            routeName: "",
            fontIsLoaded: false,
            isInvisible: true,
            isLangModalOpen: false,
            isCloseBurger: true,
            windowWidth: window.innerWidth,
        };
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.checkAccess;
        },
        ...mapGetters({
            notifications: "notifications",
            notificationCounter: "notificationsUnreadCount",
            getModalTypes: "getModalTypes",
            getIsPaymentModalActiveType: "getIsPaymentModalActiveType",
            getMyAllTarrifs: "getMyAllTarrifs",
            getUserInfoForPayment: "getUserInfoForPayment",
            getAlreadyActivateOneSum: "getAlreadyActivateOneSum",
            getIsTelegram: "getIsTelegram",
            getIsFullScreenOpen: "getIsFullScreenOpen",
        }),
    },
    watch: {
        $route(to, from) {
            // this.verifyAccess(to);

            if (!localStorage.getItem("lang")) {
                localStorage.setItem("lang", "ru");
            }

            this.routeName = to.name;
            this.change();

            if (to.name === "search") {
                this.headerMenu = "search";
            } else if (to.name === "tv") {
                this.headerMenu = "tv";
            } else {
                this.headerMenu = to.name;
            }
        },
    },
    mounted() {
        this.routeName = this.$route.name;
        if (this.notifications?.length === 0) {
            this.fetchNotifications();
        }
        window.addEventListener("scroll", this.change, false);
        window.addEventListener("resize", this.windowResize);
        const that = this;
        document.fonts.ready.then(function () {
            that.fontIsLoaded = true;
        });
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.windowResize);
    },
    methods: {
        ...mapActions(["fetchNotifications"]),
        paymnetSuccess() {
            if (this.getIsPaymentModalActiveType === "cabinet") {
                this.$router.push({
                    name: "cabinet",
                });
                this.$store.commit("setIsPaymentModalActive", false);
            }
        },
        payPerAction() {
            if (!this.isLoggedIn) {
                this.$router.push({
                    name: "login",
                });
            } else {
                this.$store.commit("setIsPaymentModalActiveType", "cabinet");
                this.$store.commit("setIsPaymentModalActive", true);
                this.getTariffsList();
            }
        },
        async sortAllTArrifs() {
            let response = [];
            if (!this.getMyAllTarrifs) {
                response = await GetAllTarrifs();
            } else {
                response = this.getMyAllTarrifs;
            }

            const result = response.flatMap((item) =>
                item.tariffs.map((tariff) => ({
                    ...tariff,
                    category: {
                        id: item.id,
                        name: item.name,
                    },
                }))
            );
            return result;
        },
        async getTariffsList() {
            if (this.isLoggedIn) {
                const middleResponse = await fetchCustomerTariffList(); // Список тарифов из мидлы
                const interlayerResponse = await this.sortAllTArrifs(); // Список тарифов из прослойки

                const moreOptions = interlayerResponse.map((item) => {
                    return {
                        ...item,
                        price: parseInt(
                            middleResponse.find(
                                (tariff) => tariff.id === item.tariff_id
                            )?.price
                        ),
                        price_after_activation: parseInt(
                            middleResponse.find(
                                (tariff) => tariff.id === item.tariff_id
                            )?.price_after_activation
                        ),
                    };
                });

                const subscriptions = await subscriptionList();
                this.getMayTArrifs(moreOptions, subscriptions);
            }
        },

        async getMayTArrifs(interlayerResponse, subscriptions) {
            const userSubscriptions = Array.isArray(subscriptions)
                ? subscriptions
                : [subscriptions];

            const tempTariffCopy = JSON.parse(
                JSON.stringify(interlayerResponse)
            );

            for (let index = 0; index < tempTariffCopy.length; index++) {
                const tarProsloyka = tempTariffCopy[index];
                if (userSubscriptions.length) {
                    for (let idx = 0; idx < userSubscriptions.length; idx++) {
                        const tarUser = userSubscriptions[idx];
                        if (tarUser.tariff_id === tarProsloyka.tariff_id) {
                            tarProsloyka.is_periodical = tarUser.is_periodical;
                            tarProsloyka.subscription_end_date =
                                tarUser.end_date;
                            tarProsloyka.is_assigned = 1;
                            tarProsloyka.start_date = tarUser.start_date;
                            tarProsloyka.period = 30;
                        }
                    }
                }

                for (let j = 0; j < tarProsloyka.sub_tariffs.length; j++) {
                    const subTarifProsloyka = tarProsloyka.sub_tariffs[j];
                    for (let k = 0; k < userSubscriptions.length; k++) {
                        const userTarriff = userSubscriptions[k];

                        if (
                            userTarriff.tariff_id ===
                            subTarifProsloyka.remote_tariff_id
                        ) {
                            tarProsloyka.is_periodical =
                                userTarriff.is_periodical;
                            const string =
                                subTarifProsloyka.period_ru.match(/\d+/);
                            const days = string ? Number(string[0]) : 30;
                            tarProsloyka.is_assigned = 1;

                            tarProsloyka.price = userTarriff.price;
                            tarProsloyka.start_date = userTarriff.start_date;
                            tarProsloyka.end_date = userTarriff.end_date;
                            tarProsloyka.period = 30000;
                            tarProsloyka.tariff_id = userTarriff.tariff_id;
                            tarProsloyka.subscription_end_date =
                                userTarriff.end_date;

                            break;
                        }
                    }
                }
            }

            const newPrice = tempTariffCopy.map((item) => {
                if (item.sub_tariffs.length) {
                    item.sub_tariffs = item.sub_tariffs.map((sub) => {
                        if (sub.remote_tariff_id === item.tariff_id) {
                            sub.price = item.price;
                        }
                        return sub;
                    });
                }
                return item;
            });

            this.myTariffs = tempTariffCopy.filter(
                (tariff) => tariff.is_assigned === 1
            );
            this.currenttarrif = tempTariffCopy.find(
                (item) => item.tariff_id === 100
            );

            this.$store.commit("setCurrentTarrif", this.currenttarrif);

            return tempTariffCopy;
        },
        windowResize() {
            this.windowWidth = window.innerWidth;
        },
        getLink(item) {
            return item.link === "/tv"
                ? {
                      name: item.name,
                      params: {
                          lang: this.$i18n.locale === "ru" ? "" : "uz",
                      },
                  }
                : item.link;
        },
        change() {
            if (window.scrollY > 34) {
                this.isInvisible = false;
            } else {
                this.isInvisible = true;
            }
        },
        changeBurger(condition) {
            condition
                ? (this.isCloseBurger = true)
                : (this.isCloseBurger = false);
            document.body.className = !condition ? "hidden" : "auto";
        },
        SearchCheck() {
            const query = this.$router.currentRoute.value.query.q;
            if (query) {
                window.scrollTo({ top: 0, behavior: "smooth" });
            } else {
                this.$router.push({
                    path: "/search",
                    name: "search",
                });
            }
        },
        langTo(lang) {
            this.$i18n.locale = lang;
            localStorage.setItem("lang", lang);
            if (this.$route.name === "blogs") {
                this.$router.push({
                    name: "blogs",
                    params: { lang: this.$i18n.locale === "ru" ? "" : "uz" },
                });
            }
            if (this.$route.name === "tv") {
                this.$router.push({
                    name: "tv",
                    params: { lang: this.$i18n.locale === "ru" ? "" : "uz" },
                });
            }
            if (this.$route.name === "news") {
                this.$router.push({
                    name: "news",
                    params: {
                        lang: this.$i18n.locale === "ru" ? "" : "uz",
                        id: this.$route.params.id,
                    },
                });
            }
            if (this.$route.name === "channel") {
                this.$router.push({
                    name: "channel",
                    params: {
                        lang: this.$i18n.locale === "ru" ? "" : "uz",
                        id: this.$route.params.id,
                    },
                });
            }
            this.toggleLang();
        },

        toggleLang(e) {
            this.isLangModalOpen = !this.isLangModalOpen;
        },
        closeLang() {
            this.isLangModalOpen = false;
        },
        clickedLink(e, navigate) {
            e.preventDefault();
            e.stopPropagation();

            const { currentRoute } = this.$router;

            if (currentRoute.value?.name === "home") {
                window.scrollTo({ top: 0, behavior: "smooth" });
            } else {
                navigate(); // переходим на home, если мы на другой странице
            }
        },
    },
    setup() {
        const instance = getCurrentInstance();
        const removeActive = () => {
            if (instance && instance.proxy) {
                instance.proxy.closeLang();
            }
        };
        useEventListener(window, "click", (e) => {
            if (
                !e.target.classList.contains("wrapperLang") &&
                !e.target.classList.contains("langItem")
            ) {
                removeActive();
            }
        });
    },
};
</script>

<style lang="scss">
.header {
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1001;
    background: #000;
    box-shadow: 0 0 13px 1px #ffffff26;
    transition: background 0.3s ease;
    --navToBurderWindiwWidth: 1200px;
    height: var(--header-height);
    &.isTelegram {
        .header__container {
            display: none;
            visibility: hidden;
        }
    }
    &.transparent {
        background: transparent;
        box-shadow: none;
    }
    &.index {
        position: fixed;
    }
    &__container {
        width: 90%;
        margin: 0 auto;
        height: 100%;
        visibility: visible;
    }
    &__wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px 0;
        height: 100%;
    }
    &__left {
        display: flex;
        align-items: center;
        gap: 15px;
        &_burger {
            display: none;
            cursor: pointer;
            flex-direction: column;
            height: 19px;
            justify-content: space-between;
            width: 27px;
            &_line {
                background-color: #fff;
                border-radius: 3px;
                height: 3px;
                width: 100%;
            }
            @media (max-width: 1200px) {
                display: flex;
            }
            @media (max-width: 450px) {
                width: 22px;
                height: 17px;
                &_line {
                    height: 2px;
                }
            }
        }
        &_logo {
            display: flex;
            align-items: center;
            gap: 10px;
            &_img {
                display: flex;
                justify-content: center;
                align-items: center;
                svg {
                    height: 30px;
                    @media (max-width: 575.98px) {
                        height: 25px;
                    }
                    @media (max-width: 450px) {
                        height: 23px;
                    }
                }
            }
        }
    }
    &__center {
        @media (max-width: 1200px) {
            display: none;
        }
    }
    &__list {
        display: flex;
        align-items: center;
        gap: 15px;
        list-style: none;
        &_link {
            cursor: pointer;
            color: #fff;
            text-decoration: none;
            font-size: 18px;
            white-space: nowrap;
            position: relative;
            transition: color 0.3s ease;
            &::before {
                content: "";
                position: absolute;
                bottom: -4px;
                left: 50%;
                width: 0;
                height: 1px;
                background: var(--primary);
                transition: 0.3s ease-in-out;
            }
            &.router-link-exact-active {
                &::before {
                    left: 0;
                    width: 100%;
                }
            }
            &:hover {
                color: var(--primary);
            }
        }
    }
    &__right {
        list-style: none;
        display: flex;
        align-items: center;
        gap: 20px;
        // @media (max-width: 420px) {
        //     gap: 15px;
        // }
        @media (max-width: 450px) {
            gap: 18px;
        }
        &__icon {
            width: 28px;
            height: 28px;
            @media (max-width: 450px) {
                width: 21px;
                height: 21px;
            }
            &_btn {
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                background: transparent;
                border: none;
                outline: none;
                color: #fff;
                transition: 0.3s ease;
                svg {
                    width: 100%;
                    height: 100%;
                }
                &:hover {
                    color: var(--primary);
                }
                &.router-link-exact-active {
                    color: var(--primary);
                }
            }
            &--accaunt {
                .header__right__icon_btn {
                    color: var(--primary);
                }
            }
            &--notification {
                width: 25px;
                height: 25px;
                @media (max-width: 575.98px) {
                    display: none;
                }
                .header__right__icon_btn {
                    position: relative;
                    &::after {
                        content: attr(data-counter);
                        position: absolute;
                        top: -5px;
                        right: -5px;
                        width: 15px;
                        height: 15px;
                        background: var(--primary);
                        color: #fff;
                        border-radius: 50%;
                        display: none;
                        justify-content: center;
                        align-items: center;
                        font-size: 10px;
                    }
                    &--active {
                        &::after {
                            display: flex;
                        }
                    }
                }
            }
            &--enter {
                width: auto;
                height: auto;
                .el-button {
                    --padding-x: 0;
                    width: 83px;
                }
                &-mobile {
                    display: none;
                    @media (max-width: 500px) {
                        display: flex;
                    }
                }

                @media (max-width: 500px) {
                    display: none;
                }
                // @media (max-width: 450px) {
                //     .el-button {
                //         &.mini {
                //             display: flex;
                //             --height: 40px;
                //             --svg--size: 18px;
                //         }
                //     }
                // }
            }
            &--promo {
                width: auto;
                height: auto;
                .el-button {
                    --background: #0abab5;
                    --outline--gradient: linear-gradient(
                        94deg,
                        #067f7c 2.94%,
                        /* темный оттенок Тиффани */ #9ae7e6 51.15%,
                        /* светлый оттенок Тиффани */ #048f8c 96.54%
                            /* средний оттенок Тиффани */
                    );
                    &.big {
                        &.is-small {
                            --svg--size: 20px;
                            --padding-x: 35px;
                            --font--size: 18px;
                            --height: 45px;
                        }
                    }
                    &.mini {
                        display: none;
                        &.is-small {
                            --svg--size: 20px;
                            --font--size: 18px;
                            --height: 45px;
                            @media (max-width: 450px) {
                                --height: 40px;
                                --svg--size: 18px;
                            }
                        }
                    }
                    &__text {
                        white-space: nowrap;
                    }
                    svg {
                        width: 100%;
                        height: 100%;
                    }
                    @media (max-width: 1399.98px) {
                        &.mini {
                            display: flex;
                        }
                        &.big {
                            display: none;
                        }
                    }
                    @media (max-width: 1199.98px) {
                        &.mini {
                            display: none;
                        }
                        &.big {
                            display: flex;
                        }
                    }
                    @media (max-width: 767.98px) {
                        &.mini {
                            display: flex;
                        }
                        &.big {
                            display: none;
                        }
                    }
                }
            }
        }
    }
    .wrapperLang {
        position: relative;
        cursor: pointer;
        background: none;
        border: none;
        width: 100%;
        height: 100%;
        &__current {
            width: 100%;
            height: 100%;
            flex-shrink: 0;
            // background: #fff;
            color: #fff;
            // border-radius: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-transform: uppercase;
            font-weight: 700;
            pointer-events: none;
            text-align: center;
            font-size: 18px;
            transition: 0.3s ease;
            @media (max-width: 450px) {
                font-size: 14px;
            }
        }
        .langModal {
            padding-top: 18px;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: 28px;
            width: max-content;
            max-height: 0;
            opacity: 0;
            pointer-events: none;
            transition: 0.2s;
            overflow: hidden;
            font-size: 16px;
            display: flex;
            flex-direction: column;
        }
        &-open {
            .langModal {
                max-height: 98px;
                opacity: 1;
                pointer-events: all;
            }
        }
        .langItem {
            padding: 10px;
            margin-top: 0;
            font-family: "Suisse Intl";
            text-align: center;
            position: relative;
            z-index: 2;
            color: #fff;
            background-color: #000;
            // border-radius: 0 0 7px 7px;
            border: none;
            cursor: pointer;
            &.firstLangItem {
                // border-radius: 7px 7px 0 0;
                border-top: 1px solid var(--primary);
                // &::before {
                // position: absolute;
                // content: "";
                // top: -15px;
                // left: 50%;
                // width: 0;
                // height: 0;
                // border-top: 10px solid transparent;
                // border-bottom: 10px solid transparent;
                // border-right: 12px solid #fff;
                // transform: rotate(90deg) translateY(6px);
                // }
            }
            &.activeLang {
                color: var(--primary);
            }
        }
    }
}
</style>
